import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isWebPaymentDark, toggleWebPaymentDarkMode } from '../webPaymentTheme';
import { IconMoon, IconSun } from './icons/HeaderUiIcons';

type ThemeToggleProps = {
  /** Fixed corner (rutas sin header booking/gym). */
  floating?: boolean;
};

export function ThemeToggle({ floating = false }: ThemeToggleProps) {
  const { t } = useTranslation();
  const [dark, setDark] = useState(() =>
    typeof document !== 'undefined' ? isWebPaymentDark() : false,
  );

  useEffect(() => {
    setDark(isWebPaymentDark());
  }, []);

  const label = dark ? t('theme.light') : t('theme.dark');

  return (
    <button
      type="button"
      className={`wp-theme-toggle${floating ? ' wp-theme-toggle--floating' : ''}`}
      onClick={() => setDark(toggleWebPaymentDarkMode())}
      aria-label={label}
      title={label}
    >
      {dark ? <IconSun aria-hidden /> : <IconMoon aria-hidden />}
    </button>
  );
}
